import {
  GridIcon,
  InsightsIcon,
  IterationIcon,
  TimelineIcon,
  TrackerIcon,
  WeekIcon,
} from './icons'
import { navigate, type Route } from '../lib/router'

const TABS: Array<{ route: Route; label: string; Icon: typeof GridIcon }> = [
  { route: 'now', label: 'Now', Icon: GridIcon },
  { route: 'today', label: 'Today', Icon: TimelineIcon },
  { route: 'week', label: 'Week', Icon: WeekIcon },
  { route: 'track', label: 'Track', Icon: TrackerIcon },
  { route: 'iterations', label: 'Iter', Icon: IterationIcon },
  { route: 'insights', label: 'Insights', Icon: InsightsIcon },
]

export function TabBar({ current }: { current: Route }) {
  return (
    <nav
      aria-label="Sections"
      className="pb-safe sticky bottom-0 z-20 border-t border-line bg-bg"
    >
      <ul className="mx-auto flex max-w-xl">
        {TABS.map(({ route, label, Icon }) => {
          const active = current === route
          return (
            <li key={route} className="flex-1">
              <button
                type="button"
                onClick={() => navigate(route)}
                aria-current={active ? 'page' : undefined}
                className={`flex h-15 w-full flex-col items-center justify-center gap-1 transition-colors duration-150 ease-[var(--ease-out-quick)] ${
                  active ? 'text-text' : 'text-faint active:text-dim'
                }`}
              >
                <Icon />
                <span className="text-[12px] leading-none font-medium tracking-wide">{label}</span>
              </button>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
